var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterviewOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.184 4.728l2.355 2.378V7.1l3.647 3.712.46-.472a1.914 1.914 0 00.288-2.369L8.056 2.962a1.256 1.256 0 00-1.906-.05L4.545 4.525a1.29 1.29 0 011.639.203zm3.832 9.078a1.29 1.29 0 00-.118.119 1.305 1.305 0 00-.31.85 1.289 1.289 0 001.278 1.3c.26 0 .512-.08.723-.23.128-.09.239-.203.326-.332l3.21-3.271a1.306 1.306 0 00.048-1.941l.011-.012-1.593-1.623a1.352 1.352 0 01-.2 1.673l-3.375 3.467zm9.371-9.353l-1.879 1.685a7.684 7.684 0 011.986 5.235 7.76 7.76 0 01-.313 2.126l.024.025-.024-.025c-.888 3.203-3.85 5.432-7.24 5.448-4.223-.117-7.551-3.56-7.438-7.693a7.672 7.672 0 012.15-5.285l-.495-.5a1.813 1.813 0 00-1.992-.482A10.25 10.25 0 002 11.235c-.044 5.623 4.398 10.218 9.92 10.265 5.522.046 10.034-4.483 10.08-10.107a10.25 10.25 0 00-2.613-6.94z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewOutline);
export default __webpack_public_path__ + "03fb9846ae3342385bbfb6f13b01a6de.svg";
export { ForwardRef as ReactComponent };